import {
  ChangeDetectionStrategy,
  Component,
  InjectionToken,
  computed,
  inject,
} from '@angular/core';

import { SS_STEPPER, StepperComponent } from '../stepper.component';

export const SS_STEP = new InjectionToken<StepComponent>('Step Component');

@Component({
  selector: 'ss-www-step',
  imports: [],
  templateUrl: './step.component.html',
  styleUrl: './step.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{ provide: SS_STEP, useExisting: StepComponent }],
})
export class StepComponent {
  private stepper = inject<StepperComponent>(SS_STEPPER, { optional: true });

  stepperIndex = computed(() => this.stepper?._steps()?.indexOf(this) ?? 0);
  totalSteps = computed(() => this.stepper?._steps()?.length ?? 0);
}
